import { extractMongoObjectIdHex } from "./helpers";

/**
 * Admin user list filters (expects GET /usuarios with populated cursosInscritos for course-id checks).
 * @param {{ nombre?: string; dni?: string; cursosInscritos?: Array<{ _id?: unknown } | string> }} usuario
 * @param {string} busqueda
 * @returns {boolean}
 */
export function matchesUserTextSearch(usuario, busqueda) {
  const cleanSearchText = (value) =>
    String(value ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  const query = typeof busqueda === "string" ? cleanSearchText(busqueda.trim()) : "";
  if (query === "") {
    return true;
  }
  const nombre = typeof usuario?.nombre === "string" ? cleanSearchText(usuario.nombre) : "";
  const dni = typeof usuario?.dni === "string" ? cleanSearchText(usuario.dni) : "";
  return nombre.includes(query) || dni.includes(query);
}

/**
 * @param {unknown} entry - ObjectId, populated curso, or string id
 * @returns {string}
 */
function enrolledCourseIdFromEntry(entry) {
  if (entry == null) {
    return "";
  }
  if (typeof entry === "string") {
    return extractMongoObjectIdHex(entry) || entry.trim();
  }
  if (typeof entry === "object" && !Array.isArray(entry) && entry._id != null) {
    return extractMongoObjectIdHex(entry._id) || "";
  }
  return extractMongoObjectIdHex(entry) || "";
}

/**
 * @param {{ rol?: string }} usuario
 * @param {string} rolFiltro - empty = all roles
 * @returns {boolean}
 */
export function userMatchesRoleFilter(usuario, rolFiltro) {
  const target = typeof rolFiltro === "string" ? rolFiltro.trim().toLowerCase() : "";
  if (target === "") {
    return true;
  }
  const rol = typeof usuario?.rol === "string" ? usuario.rol.trim().toLowerCase() : "";
  return rol === target;
}

/**
 * @param {{ cursosInscritos?: Array<{ _id?: unknown } | string> }} usuario
 * @param {string} courseId - Hex id; empty = no filter (all users)
 * @returns {boolean}
 */
export function userEnrolledInCourseId(usuario, courseId) {
  const target =
    extractMongoObjectIdHex(courseId) ||
    (typeof courseId === "string" ? courseId.trim() : "");
  if (target === "") {
    return true;
  }
  const cursos = usuario?.cursosInscritos;
  if (!Array.isArray(cursos)) {
    return false;
  }
  for (const curso of cursos) {
    if (enrolledCourseIdFromEntry(curso) === target) {
      return true;
    }
  }
  return false;
}
